// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__37SKg","topBottomGutter":"Layout_topBottomGutter__9dVsU"};